import React from "react";
import { InputText } from "@vernost_dev/vms-react-components/dist/InputText";

const VmsInputText = (props) => {
  const { placeholder, value, messageMode, msgText, label, name, type, id, onClick, readOnly, className, onBlur = () => { }, onFocus = () => { }, onChange = () => { }, tabIndex, maxLength, minLength, disabled, rightView, leftView, autoFocus } = props;

  return (
    <InputText
      readOnly={readOnly}
      msgText={msgText}
      messageMode={messageMode}
      label={label}
      value={value}
      name={name}
      type={type}
      id={id}
      placeholder={placeholder}
      additionalClassName={className}
      onClick={onClick}
      onChange={(e) => onChange(e)}
      onBlur={(e) => onBlur(e)}
      onFocus={(e) => onFocus(e)}
      tabIndex={tabIndex}
      maxLength={maxLength}
      minLength={minLength}
      disabled={disabled}
      rightView={rightView}
      leftView={leftView}
      autoFocus={autoFocus}
    />
  );
};

export { VmsInputText };
